module.exports = __webpack_public_path__ + "img/buttonicon3.17fb8224.png";